<template>
	<div class="cont_box">
		<gallerys ref="gallerys" ></gallerys>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	import gallerys from '@/components/gallerys';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				isFlag: true,
				tab_index: 'tk',
				currentPage3: 5,
				gallFlag: true
			}
		},
		filters: {
			tabname() {
				let name = ''
				for (let item of this.fl)
					return this.$route.params.code
			}
		},
		computed: {
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.$route.params.code) {
						name = item.name
					}
				}
				return name
			},
			fldata() {
				return this.$store.state.fldata
			},
		},
		methods: {
			slt_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		components: {
			headers,
			foot,
			gallerys
		}
	}
</script>

<style lang="less" scoped>
	.gall_box {
		width: 870px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 30px;
			padding-top: 37px;

			span {
				font-size: 13px;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}

		.gall_fy {
			margin: 30px 0 60px;

			.block {
				display: flex;
				justify-content: center;
			}
		}

		.gall_cont {
			.gall_item {
				margin-top: 21px;

				.gall_item_title {
					height: 38px;
					background: #F5F5F5;
					padding-left: 23px;
					font-size: 15px;
					color: #333333;
					line-height: 38px;
				}

				.gall_item_p {
					padding: 18px 0 0 23px;
					display: flex;
					flex-wrap: wrap;

					.gall_item_a {
						color: #4A4A4A;
						font-size: 13px;
						margin-bottom: 23px;
						margin-right: 17px;
						text-decoration: underline;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
